<template>
  <div class="search-box">
    <div class="game-more-title">
      <el-row>
        <el-col :span="IsMobile ? 24 : 4">
          <!-- 首页游戏展示过来 -->
          <div v-if="cur_params.bindType === 2 && cur_params.list" class="g-title" style="text-transform: capitalize">
            <div>{{ $utils.lang_data(lang, cur_params.list[0], "langInfoObj")?.title || " " }}</div>
            <img
              class="mode-icon"
              v-if="cur_params.list[0]"
              :src="$utils.returnImgUrl($utils.lang_data(lang, cur_params.list[0], 'langInfoObj')?.icon)"
              alt
            />
          </div>
          <!-- 首页厂商展示过来 -->
          <div
            v-if="cur_params.bindType === 3 && cur_params.langInfoObj"
            class="g-title"
            style="text-transform: capitalize; padding-left: 0"
          >
            <div>{{ $utils.lang_data(lang, cur_params, "langInfoObj")?.name }}</div>
            <!-- <img
              class="mode-icon"
              v-if="cur_params.langInfoObj[lang]?.icon"
              :src="$utils.returnImgUrl(cur_params.langInfoObj[lang]?.icon, true)"
              alt
            /> -->
          </div>
          <!-- 菜单页面过来 -->
          <div
            v-if="cur_params.bindType === 1 && cur_params.language"
            class="g-title"
            style="text-transform: capitalize"
          >
            <div>{{ cur_params.language.name }}</div>
            <img
              class="mode-icon"
              v-if="cur_params.language.iconSmall || cur_params.language.icon"
              :src="getIconMap(cur_params.language, 3)"
              alt
            />
          </div>
        </el-col>
        <el-col :span="20" v-if="!IsMobile" style="margin-top: 18px">
          <div style="text-align: right">
            <div class="flex-col" style="margin-right: 30px" v-if="brandGroupGameList.length > 1">
              <label class="formDataLabel color900">{{ $t("Datalang.home_Filtering_method") }}</label>
              <el-select
                class="formDateSel"
                v-model="gameForm.brandGroupSid"
                clearable
                size="medium"
                :placeholder="$t('Datalang.home_Supplier')"
                @change="getGamelistFun(1)"
              >
                <el-option
                  v-for="item in brandGroupGameList"
                  :key="item.brandGroupSid"
                  :label="item.brandGroupName + ` (${item.gameGroupCount})`"
                  :value="item.brandGroupSid"
                ></el-option>
              </el-select>
            </div>
            <div class="flex-col">
              <label class="formDataLabel color900">{{ $t("Datalang.home_Sorting_method") }}</label>
              <el-select class="formDateSel" v-model="gameForm.sortType" size="medium" @change="getGamelistFun(1)">
                <el-option
                  v-for="item in sortTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
        </el-col>
        <div class="search-wrap" v-if="IsMobile">
          <el-row :gutter="10">
            <!-- 暂时注释厂商、标签、玩法查询 -->
            <!-- <el-col :span="8">
              <el-select
                v-model="gameForm.brandGroupSid"
                clearable
                :placeholder="$t('Datalang.Betrecord_TITLE_provider')"
                style="width: 100%"
                size="medium"
                @change="getGamelistFun(1)"
              >
                <el-option
                  v-for="item in brandGroupList"
                  :key="item.sid"
                  :label="item.name"
                  :value="item.sid"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-select
                v-model="gameForm.gameTagSid"
                clearable
                :placeholder="$t('Datalang.HomePage_tag')"
                style="width: 100%"
                size="medium"
                @change="getGamelistFun(1)"
              >
                <el-option v-for="item in tagList" :key="item.sid" :label="item.name" :value="item.sid"></el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-select
                v-model="gameForm.gamePlayTypeSid"
                clearable
                :placeholder="$t('Datalang.HomePage_playmode')"
                style="width: 100%"
                size="medium"
                @change="getGamelistFun(1)"
              >
                <el-option v-for="item in playList" :key="item.sid" :label="item.name" :value="item.sid"></el-option>
              </el-select>
            </el-col> -->
            <!-- <el-col :span="IsMobile ? 24 : 8" :offset="IsMobile ? 0 : 4">
              <el-input
                class="search-input"
                v-model="gameForm.gameGroupName"
                style="width: 100%"
                size="medium"
                prefix-icon="el-icon-search"
                @input="keyWordFun"
              ></el-input>
            </el-col> -->
            <el-col :xs="12" :sm="12" v-if="brandGroupGameList.length > 1">
              <el-select
                class="formDateSel"
                v-model="gameForm.brandGroupSid"
                clearable
                size="medium"
                :placeholder="$t('Datalang.home_Supplier')"
                @change="getGamelistFun(1)"
              >
                <el-option
                  v-for="item in brandGroupGameList"
                  :key="item.brandGroupSid"
                  :label="item.brandGroupName + ` (${item.gameGroupCount})`"
                  :value="item.brandGroupSid"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :xs="12" :sm="12">
              <el-select class="formDateSel" v-model="gameForm.sortType" size="medium" @change="getGamelistFun(1)">
                <el-option
                  v-for="item in sortTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
      </el-row>
    </div>
    <div ref="scrollWrap">
      <div
        class="content-wrap"
        :style="{ position: 'relative', top: $px2rem(retop), zIndex: 1 }"
        ref="contentWrap1"
        v-if="list.length > 0"
      >
        <div class="p-hot-box hidden-xs-only">
          <template v-for="(item, i) in list">
            <div
              class="img-box"
              v-if="hidegd(item)"
              :key="'pc_' + i"
              :class="{ 'mr-0': (i + 1) % 7 === 0 }"
              :style="{ animationDelay: getAnimationDelay(i) }"
            >
              <gameItem :item="item" />
            </div>
          </template>
          <div class="more-btn-box" v-if="isMore && zhanwutype === true">
            <div class="more-btn" v-loading="loading" @click="moreFun">{{ $t("Datalang.HomePage_BTM_loadmore") }}</div>
          </div>
        </div>
        <div class="p-hot-box hidden-sm-and-up">
          <template v-for="(item, i) in list">
            <div
              class="img-box h5-box"
              v-if="hidegd(item)"
              :key="'h5_' + i"
              :class="{ 'mr-0': (i + 1) % 3 === 0 }"
              :style="{ animationDelay: getAnimationDelay(i) }"
            >
              <gameItem :item="item" />
            </div>
          </template>
          <!-- <div v-if="list.length < total && zhanwutype === true" class="img-box h5-box more-box" @click="moreFun">
            <el-image class="item-img" :src="moreIcon"> </el-image>
            <div class="txts" @click="moreFun">{{ $t("Datalang.HomePage_BTM_loadmore") }}</div>
          </div>-->
          <div class="more-btn-box" id="moreBtnBox" v-if="isMore && zhanwutype === true">
            <div class="more-btn" v-loading="loading"></div>
            <!-- <div class="more-btn" @click="moreFun">{{ $t("Datalang.HomePage_BTM_loadmore") }}</div> -->
          </div>
        </div>
      </div>
      <div v-if="list.length == 0 && zhanwutype === true" class="zanwu">
        <img :src="zanwu" alt />
        <div>{{ $t("Datalang.Invite_TITLE_nodatanow") }}</div>
      </div>

      <!-- <game-hot :isHistory="true" v-show="showGameHot"></game-hot> -->
    </div>
  </div>
</template>

<script>
import HomeSearchGame from "@/lobby_common/mixins_views/homeSearch/HomeSearchGame.js";
export default {
  mixins: [HomeSearchGame],
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.search-box {
  padding: 10px 30px;
  @media (max-width: 768px) {
    padding: 10px 15px;
  }
}
.game-more-title {
  line-height: 42px;
  margin-bottom: 16px;
  font-size: 21px;
  overflow: hidden;
  @media (max-width: 768px) {
    margin-bottom: 0px;
  }
  .g-title {
    position: relative;
    // padding-left: 46px;
    padding-left: 35px;
    margin: 25px 0 20px 0;
    font-size: 18px;
    line-height: 28px;
    @media (max-width: 768px) {
      margin: 15px 0;
    }
    & > .sprite-icon {
      left: 0;
      cursor: pointer;
      transform: translateY(-50%) scale(0.78);
    }
    .arrowIcon {
      opacity: 1;
      &:hover {
        opacity: 0.7;
      }
    }
    .mode-icon {
      position: absolute;
      left: 0;
      top: 3px;
      max-width: 25px;
      height: 24px;
    }
  }
  .more {
    height: 42px;
    line-height: 42px;
    font-size: 16px;
    margin-bottom: 10px;
    cursor: pointer;
    ::v-deep .el-input__icon {
      width: 42px;
      line-height: 42px;
    }
    ::v-deep .el-input__icon {
      font-size: 20px;
    }
  }
  ::v-deep .el-input {
    font-size: 14px;
    .el-input__inner {
      height: 42px;
      line-height: 42px;
      @media (max-width: 768px) {
        height: 32px;
        line-height: 32px;
      }
    }
    .el-icon-search {
      color: inherit;
    }
    .el-input__prefix {
      // left: auto;
      width: 30px;
      right: 5px;
    }
  }
}
.search-wrap {
  margin-bottom: 5px;
  @media (max-width: 768px) {
    margin-bottom: 15px;
  }
}
.flex-col {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}
.p-hot-box {
  width: 100%;
  overflow: hidden;
  .img-box {
    position: relative;
    display: inline-block;
    width: 13%;
    margin: 0 auto;
    margin-right: 1.5%;
    margin-bottom: 16px;
    text-align: center;
    cursor: pointer;
    &.h5-box {
      width: 30%;
      margin-right: 5%;
      & > .txt {
        font-size: 14px;
        height: 42px;
        line-height: 42px;
      }
      &.more-box {
        position: relative;
        & > .txts {
          position: absolute;
          top: 35%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
    ::v-deep .el-image__inner {
      transition: 0.5s;
      &:hover {
        transform: scale(1.4);
        transition: all 1s ease 0s;
        -webkit-transform: scale(1.4);
        -webkit-transform: all 1s ease 0s;
      }
    }
    .relative {
      img {
        max-width: 100%;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        -ms-border-radius: 20px;
        -o-border-radius: 20px;
      }
    }
    &.mr-0 {
      margin-right: 0;
    }
    &:last-child {
      margin-right: 0;
    }
    .txt {
      width: 100%;
      height: 42px;
      line-height: 42px;
      font-size: 16px;
      overflow: hidden;
      white-space: nowrap; /*不换行*/
      text-overflow: ellipsis; /*超出部分文字以...显示*/
    }
  }
}
.more-btn-box {
  width: 100%;
  padding: 20px 0;
  text-align: center;
  .more-btn {
    display: inline-block;
    padding: 0 15px;
    height: 32px;
    line-height: 32px;
    margin: 0 auto;
    border-radius: 5px;
    margin-bottom: 16px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
  }
}
.zanwu {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  // height: 100px;
  img {
    display: inline-block;
    width: 100px;
    height: 97px;
  }
}
.formDataLabel {
  display: block;
  font-size: 16px;
  line-height: 42px;
  // width: 100%;
  font-weight: bold;
  margin-right: 6px;
  @media (max-width: 768px) {
    font-size: 15px;
  }
}
.formDateSel {
  width: 180px;
  @media (max-width: 768px) {
    width: 100%;
  }
  ::v-deep .el-input__inner {
    height: 50px;
    border-radius: 5px !important;
    @media (max-width: 768px) {
      height: 32px;
      border-radius: 3px !important;
    }
  }
}
.color900 {
  color: var(--font-color-900);
}
.img-box {
  -webkit-animation: ping 0.4s cubic-bezier(0, 0, 0.2, 1) forwards;
  animation: ping 0.4s cubic-bezier(0, 0, 0.2, 1) forwards;
  opacity: 0;
}
@keyframes ping {
  50% {
    -webkit-transform: scale(0.1);
    -ms-transform: scale(0.1);
    transform: scale(0.1);
    opacity: 0;
  }
  100% {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
}
</style>
